import RsaPazienteMainPage from "./pages/RsaPazienteMainPage.vue";

export default {
	RsaPazienteMainPage,
};
